import type { ColorName } from ".";

export const HTMLColorNames: Array<ColorName> = [
  {
    name: "AliceBlue",
    rgb: "rgb(240, 248, 255)",
  },
  {
    name: "AntiqueWhite",
    rgb: "rgb(250, 235, 215)",
  },
  {
    name: "Aqua",
    rgb: "rgb(0, 255, 255)",
  },
  {
    name: "Aquamarine",
    rgb: "rgb(127, 255, 212)",
  },
  {
    name: "Azure",
    rgb: "rgb(240, 255, 255)",
  },
  {
    name: "Beige",
    rgb: "rgb(245, 245, 220)",
  },
  {
    name: "Bisque",
    rgb: "rgb(255, 228, 196)",
  },
  {
    name: "Black",
    rgb: "rgb(0, 0, 0)",
  },
  {
    name: "BlanchedAlmond",
    rgb: "rgb(255, 235, 205)",
  },
  {
    name: "Blue",
    rgb: "rgb(0, 0, 255)",
  },
  {
    name: "BlueViolet",
    rgb: "rgb(138, 43, 226)",
  },
  {
    name: "Brown",
    rgb: "rgb(165, 42, 42)",
  },
  {
    name: "BurlyWood",
    rgb: "rgb(222, 184, 135)",
  },
  {
    name: "CadetBlue",
    rgb: "rgb(95, 158, 160)",
  },
  {
    name: "Chartreuse",
    rgb: "rgb(127, 255, 0)",
  },
  {
    name: "Chocolate",
    rgb: "rgb(210, 105, 30)",
  },
  {
    name: "Coral",
    rgb: "rgb(255, 127, 80)",
  },
  {
    name: "CornflowerBlue",
    rgb: "rgb(100, 149, 237)",
  },
  {
    name: "Cornsilk",
    rgb: "rgb(255, 248, 220)",
  },
  {
    name: "Crimson",
    rgb: "rgb(220, 20, 60)",
  },
  {
    name: "Cyan",
    rgb: "rgb(0, 255, 255)",
  },
  {
    name: "DarkBlue",
    rgb: "rgb(0, 0, 139)",
  },
  {
    name: "DarkCyan",
    rgb: "rgb(0, 139, 139)",
  },
  {
    name: "DarkGoldenRod",
    rgb: "rgb(184, 134, 11)",
  },
  {
    name: "DarkGray",
    rgb: "rgb(169, 169, 169)",
  },
  {
    name: "DarkGrey",
    rgb: "rgb(169, 169, 169)",
  },
  {
    name: "DarkGreen",
    rgb: "rgb(0, 100, 0)",
  },
  {
    name: "DarkKhaki",
    rgb: "rgb(189, 183, 107)",
  },
  {
    name: "DarkMagenta",
    rgb: "rgb(139, 0, 139)",
  },
  {
    name: "DarkOliveGreen",
    rgb: "rgb(85, 107, 47)",
  },
  {
    name: "DarkOrange",
    rgb: "rgb(255, 140, 0)",
  },
  {
    name: "DarkOrchid",
    rgb: "rgb(153, 50, 204)",
  },
  {
    name: "DarkRed",
    rgb: "rgb(139, 0, 0)",
  },
  {
    name: "DarkSalmon",
    rgb: "rgb(233, 150, 122)",
  },
  {
    name: "DarkSeaGreen",
    rgb: "rgb(143, 188, 139)",
  },
  {
    name: "DarkSlateBlue",
    rgb: "rgb(72, 61, 139)",
  },
  {
    name: "DarkSlateGray",
    rgb: "rgb(47, 79, 79)",
  },
  {
    name: "DarkSlateGrey",
    rgb: "rgb(47, 79, 79)",
  },
  {
    name: "DarkTurquoise",
    rgb: "rgb(0, 206, 209)",
  },
  {
    name: "DarkViolet",
    rgb: "rgb(148, 0, 211)",
  },
  {
    name: "DeepPink",
    rgb: "rgb(255, 20, 147)",
  },
  {
    name: "DeepSkyBlue",
    rgb: "rgb(0, 191, 255)",
  },
  {
    name: "DimGray",
    rgb: "rgb(105, 105, 105)",
  },
  {
    name: "DimGrey",
    rgb: "rgb(105, 105, 105)",
  },
  {
    name: "DodgerBlue",
    rgb: "rgb(30, 144, 255)",
  },
  {
    name: "FireBrick",
    rgb: "rgb(178, 34, 34)",
  },
  {
    name: "FloralWhite",
    rgb: "rgb(255, 250, 240)",
  },
  {
    name: "ForestGreen",
    rgb: "rgb(34, 139, 34)",
  },
  {
    name: "Fuchsia",
    rgb: "rgb(255, 0, 255)",
  },
  {
    name: "Gainsboro",
    rgb: "rgb(220, 220, 220)",
  },
  {
    name: "GhostWhite",
    rgb: "rgb(248, 248, 255)",
  },
  {
    name: "Gold",
    rgb: "rgb(255, 215, 0)",
  },
  {
    name: "GoldenRod",
    rgb: "rgb(218, 165, 32)",
  },

  {
    name: "Gray",
    rgb: "rgb(128, 128, 128)",
  },
  {
    name: "Grey",
    rgb: "rgb(128, 128, 128)",
  },
  {
    name: "Green",
    rgb: "rgb(0, 128, 0)",
  },
  {
    name: "GreenYellow",
    rgb: "rgb(173, 255, 47)",
  },
  {
    name: "HoneyDew",
    rgb: "rgb(240, 255, 240)",
  },
  {
    name: "HotPink",
    rgb: "rgb(255, 105, 180)",
  },
  {
    name: "IndianRed",
    rgb: "rgb(205, 92, 92)",
  },
  {
    name: "Indigo",
    rgb: "rgb(75, 0, 130)",
  },
  {
    name: "Ivory",
    rgb: "rgb(255, 255, 240)",
  },
  {
    name: "Khaki",
    rgb: "rgb(240, 230, 140)",
  },
  {
    name: "Lavender",
    rgb: "rgb(230, 230, 250)",
  },
  {
    name: "LavenderBlush",
    rgb: "rgb(255, 240, 245)",
  },
  {
    name: "LawnGreen",
    rgb: "rgb(124, 252, 0)",
  },
  {
    name: "LemonChiffon",
    rgb: "rgb(255, 250, 205)",
  },
  {
    name: "LightBlue",
    rgb: "rgb(173, 216, 230)",
  },
  {
    name: "LightCoral",
    rgb: "rgb(240, 128, 128)",
  },
  {
    name: "LightCyan",
    rgb: "rgb(224, 255, 255)",
  },
  {
    name: "LightGoldenRodYellow",
    rgb: "rgb(250, 250, 210)",
  },
  {
    name: "LightGray",
    rgb: "rgb(211, 211, 211)",
  },
  {
    name: "LightGrey",
    rgb: "rgb(211, 211, 211)",
  },
  {
    name: "LightGreen",
    rgb: "rgb(144, 238, 144)",
  },
  {
    name: "LightPink",
    rgb: "rgb(255, 182, 193)",
  },
  {
    name: "LightSalmon",
    rgb: "rgb(255, 160, 122)",
  },
  {
    name: "LightSeaGreen",
    rgb: "rgb(32, 178, 170)",
  },
  {
    name: "LightSkyBlue",
    rgb: "rgb(135, 206, 250)",
  },
  {
    name: "LightSlateGray",
    rgb: "rgb(119, 136, 153)",
  },
  {
    name: "LightSlateGrey",
    rgb: "rgb(119, 136, 153)",
  },
  {
    name: "LightSteelBlue",
    rgb: "rgb(176, 196, 222)",
  },
  {
    name: "LightYellow",
    rgb: "rgb(255, 255, 224)",
  },
  {
    name: "Lime",
    rgb: "rgb(0, 255, 0)",
  },
  {
    name: "LimeGreen",
    rgb: "rgb(50, 205, 50)",
  },
  {
    name: "Linen",
    rgb: "rgb(250, 240, 230)",
  },
  {
    name: "Magenta",
    rgb: "rgb(255, 0, 255)",
  },
  {
    name: "Maroon",
    rgb: "rgb(128, 0, 0)",
  },
  {
    name: "MediumAquaMarine",
    rgb: "rgb(102, 205, 170)",
  },
  {
    name: "MediumBlue",
    rgb: "rgb(0, 0, 205)",
  },
  {
    name: "MediumOrchid",
    rgb: "rgb(186, 85, 211)",
  },
  {
    name: "MediumPurple",
    rgb: "rgb(147, 112, 219)",
  },
  {
    name: "MediumSeaGreen",
    rgb: "rgb(60, 179, 113)",
  },
  {
    name: "MediumSlateBlue",
    rgb: "rgb(123, 104, 238)",
  },
  {
    name: "MediumSpringGreen",
    rgb: "rgb(0, 250, 154)",
  },
  {
    name: "MediumTurquoise",
    rgb: "rgb(72, 209, 204)",
  },
  {
    name: "MediumVioletRed",
    rgb: "rgb(199, 21, 133)",
  },
  {
    name: "MidnightBlue",
    rgb: "rgb(25, 25, 112)",
  },
  {
    name: "MintCream",
    rgb: "rgb(245, 255, 250)",
  },
  {
    name: "MistyRose",
    rgb: "rgb(255, 228, 225)",
  },
  {
    name: "Moccasin",
    rgb: "rgb(255, 228, 181)",
  },
  {
    name: "NavajoWhite",
    rgb: "rgb(255, 222, 173)",
  },
  {
    name: "Navy",
    rgb: "rgb(0, 0, 128)",
  },
  {
    name: "OldLace",
    rgb: "rgb(253, 245, 230)",
  },
  {
    name: "Olive",
    rgb: "rgb(128, 128, 0)",
  },
  {
    name: "OliveDrab",
    rgb: "rgb(107, 142, 35)",
  },
  {
    name: "Orange",
    rgb: "rgb(255, 165, 0)",
  },
  {
    name: "OrangeRed",
    rgb: "rgb(255, 69, 0)",
  },
  {
    name: "Orchid",
    rgb: "rgb(218, 112, 214)",
  },
  {
    name: "PaleGoldenRod",
    rgb: "rgb(238, 232, 170)",
  },
  {
    name: "PaleGreen",
    rgb: "rgb(152, 251, 152)",
  },
  {
    name: "PaleTurquoise",
    rgb: "rgb(175, 238, 238)",
  },
  {
    name: "PaleVioletRed",
    rgb: "rgb(219, 112, 147)",
  },
  {
    name: "PapayaWhip",
    rgb: "rgb(255, 239, 213)",
  },
  {
    name: "PeachPuff",
    rgb: "rgb(255, 218, 185)",
  },
  {
    name: "Peru",
    rgb: "rgb(205, 133, 63)",
  },
  {
    name: "Pink",
    rgb: "rgb(255, 192, 203)",
  },
  {
    name: "Plum",
    rgb: "rgb(221, 160, 221)",
  },
  {
    name: "PowderBlue",
    rgb: "rgb(176, 224, 230)",
  },
  {
    name: "Purple",
    rgb: "rgb(128, 0, 128)",
  },
  {
    name: "Red",
    rgb: "rgb(255, 0, 0)",
  },
  {
    name: "RosyBrown",
    rgb: "rgb(188, 143, 143)",
  },
  {
    name: "RoyalBlue",
    rgb: "rgb(65, 105, 225)",
  },
  {
    name: "SaddleBrown",
    rgb: "rgb(139, 69, 19)",
  },
  {
    name: "Salmon",
    rgb: "rgb(250, 128, 114)",
  },
  {
    name: "SandyBrown",
    rgb: "rgb(244, 164, 96)",
  },
  {
    name: "SeaGreen",
    rgb: "rgb(46, 139, 87)",
  },
  {
    name: "SeaShell",
    rgb: "rgb(255, 245, 238)",
  },
  {
    name: "Sienna",
    rgb: "rgb(160, 82, 45)",
  },
  {
    name: "Silver",
    rgb: "rgb(192, 192, 192)",
  },
  {
    name: "SkyBlue",
    rgb: "rgb(135, 206, 235)",
  },
  {
    name: "SlateBlue",
    rgb: "rgb(106, 90, 205)",
  },
  {
    name: "SlateGray",
    rgb: "rgb(112, 128, 144)",
  },
  {
    name: "Snow",
    rgb: "rgb(255, 250, 250)",
  },
  {
    name: "SpringGreen",
    rgb: "rgb(0, 255, 127)",
  },
  {
    name: "SteelBlue",
    rgb: "rgb(70, 130, 180)",
  },
  {
    name: "Tan",
    rgb: "rgb(210, 180, 140)",
  },
  {
    name: "Teal",
    rgb: "rgb(0, 128, 128)",
  },
  {
    name: "Thistle",
    rgb: "rgb(216, 191, 216)",
  },
  {
    name: "Tomato",
    rgb: "rgb(255, 99, 71)",
  },
  {
    name: "Turquoise",
    rgb: "rgb(64, 224, 208)",
  },
  {
    name: "Violet",
    rgb: "rgb(238, 130, 238)",
  },
  {
    name: "Wheat",
    rgb: "rgb(245, 222, 179)",
  },
  {
    name: "White",
    rgb: "rgb(255, 255, 255)",
  },
  {
    name: "WhiteSmoke",
    rgb: "rgb(245, 245, 245)",
  },
  {
    name: "Yellow",
    rgb: "rgb(255, 255, 0)",
  },
  {
    name: "YellowGreen",
    rgb: "rgb(154, 205, 50)",
  },
];
